import { createSlice } from '@reduxjs/toolkit'

export const googleReviews = createSlice({
  name: 'reviews',
  initialState: {
    data: [],
    pending: "0",
    averageRating: 0,
    count: 0,
    loading: false,
    totalResult: 0,
    replyTime: 0,
    replyRate: 0,
    consoManaged: false,
    wash: {},
    ev: {}
  },
  reducers: {
    setReviews: (state, item) => {
      state.data = item.payload
    },
    setPending: (state, item) => {
      state.pending = item.payload
    },
    setLoadingReviews: (state, item) => {
      state.loading = item.payload
    },
    setAverageRating: (state, item) => {
      state.averageRating = item.payload
    },
    setCount: (state, item) => {
      state.count = item.payload
    },
    setTotalResult: (state, item) => {
      state.totalResult = item.payload
    },
    setReviewsReplyTime: (state, item) => {
      state.replyTime = item.payload
    },
    setReplyRate: (state, item) => {
      state.replyRate = item.payload
    },
    setConsoManaged: (state, item) => {
      state.consoManaged = item.payload
    },
    setWashData: (state, item) => {
      state.wash = item.payload
    },
    setEvData: (state, item) => {
      state.ev = item.payload
    }
  }
})

export const {
  setReviews, setPending, setLoadingReviews, setAverageRating,
  setCount, setTotalResult, setReviewsReplyTime, setReplyRate,
  setConsoManaged, setWashData, setEvData
} = googleReviews.actions
export default googleReviews.reducer